import { ProductKeys } from '../../../constants/product-keys';
import type { ProductConfig } from '../../../constants/products';
import type { ThirdPartyConfigsBootstrap } from '../../../constants/schemas/3p-config';

const APPS_SHOWN_IN_ICON = 3;

type IsUserOAuthedFn = (
	productKey: ProductKeys,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
) => { userNeedsOAuth: boolean | undefined };

/**
 * Returns the number of connected apps excluding the 3 shown in the All Apps icon.
 *
 * Pure utility — accepts isUserOAuthed as a parameter so it can live in common/
 * without importing from controllers/.
 */
export const getRemainingAppCount = (
	availableProducts: ProductKeys[],
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
	productConfigs: Partial<Record<ProductKeys, ProductConfig>>,
	isUserOAuthed: IsUserOAuthedFn,
): number => {
	const eligibleCount = availableProducts.filter((productKey) => {
		if (productKey === ProductKeys.Atlas || productKey === ProductKeys.AtlassianWebCrawler) {
			return false;
		}

		const { userNeedsOAuth } = isUserOAuthed(productKey, thirdPartyConfigs);
		if (userNeedsOAuth) {
			return false;
		}

		return Boolean(productConfigs[productKey]);
	}).length;

	return Math.max(0, eligibleCount - APPS_SHOWN_IN_ICON);
};
